export default __webpack_public_path__ + "static/media/triple-spicy.04407515.svg";